/**
 * @generated SignedSource<<e3a3829d9b2ee8c24525d464a977835d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type subsectionViewRendererFragment$data = {
  readonly __id: string;
  readonly config: {
    readonly span: number | null | undefined;
  } | null | undefined;
  readonly elements: ReadonlyArray<{
    readonly __id: string;
    readonly " $fragmentSpreads": FragmentRefs<"customPageElementViewRendererQueryFragment" | "elementErrorBoundaryFragment" | "homePageElementViewRendererFragment">;
  } | null | undefined> | null | undefined;
  readonly visualConfig?: {
    readonly " $fragmentSpreads": FragmentRefs<"alignmentSettingsContextFragment" | "alignmentSettingsContextHookFragment">;
  } | null | undefined;
  readonly " $fragmentType": "subsectionViewRendererFragment";
};
export type subsectionViewRendererFragment$key = {
  readonly " $data"?: subsectionViewRendererFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"subsectionViewRendererFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__relayprovidercustompagerelayprovider"
    },
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__relayproviderhomepagerelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "subsectionViewRendererFragment",
  "selections": [
    {
      "concreteType": "HelpLayoutSubsectionConfig",
      "kind": "LinkedField",
      "name": "config",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "span"
        }
      ]
    },
    {
      "kind": "LinkedField",
      "name": "elements",
      "plural": true,
      "selections": [
        {
          "condition": "__relay_internal__pv__relayproviderhomepagerelayprovider",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "homePageElementViewRendererFragment"
            }
          ]
        },
        {
          "condition": "__relay_internal__pv__relayprovidercustompagerelayprovider",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "customPageElementViewRendererQueryFragment"
            }
          ]
        },
        {
          "kind": "FragmentSpread",
          "name": "elementErrorBoundaryFragment"
        },
        (v0/*: any*/)
      ]
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "HelpLayoutVisualConfig",
          "kind": "LinkedField",
          "name": "visualConfig",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "alignmentSettingsContextFragment"
            },
            {
              "kind": "FragmentSpread",
              "name": "alignmentSettingsContextHookFragment"
            }
          ]
        }
      ],
      "type": "HelpLayoutVisualEntity",
      "abstractKey": "__isHelpLayoutVisualEntity"
    },
    (v0/*: any*/)
  ],
  "type": "HelpLayoutSubsection"
};
})();

(node as any).hash = "1c7d38fc44a964ce0d4abf7d56e65f26";

export default node;
